import { render } from "./SuperAdminSurveyStats.vue?vue&type=template&id=a192e816"
import script from "./SuperAdminSurveyStats.vue?vue&type=script&lang=js"
export * from "./SuperAdminSurveyStats.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__